import React, { useState, useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import './Hero.css';

const Hero = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: '/MRRO/medical-day/main.jpeg',
      title: t.heroTitle,
      subtitle: t.heroSubtitle,
      description: t.heroDescription
    },
    {
      image: '/MRRO/medical-day/main2.jpeg',
      title: language === 'ar' ? 'نحن نبني مستقبلاً أفضل' : 'Building a Better Future',
      subtitle: language === 'ar' ? 'معاً من أجل التغيير' : 'Together for Change',
      description: language === 'ar' ? 'انضم إلينا في رحلتنا لتمكين المجتمعات وإحداث تأثير دائم' : 'Join us in our journey to empower communities and create lasting impact'
    },
    {
      image: '/MRRO/medical-day/main3.jpeg',
      title: language === 'ar' ? 'كل مساهمة مهمة' : 'Every Contribution Matters',
      subtitle: language === 'ar' ? 'كن جزءاً من الحل' : 'Be Part of the Solution',
      description: language === 'ar' ? 'دعمك يحدث فرقاً حقيقياً في حياة المحتاجين' : 'Your support makes a real difference in the lives of those in need'
    }
  ];

  // Auto-advance slides every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="hero">
      {/* Background Image Slider */}
      <div className="hero-slider">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          />
        ))}
      </div>

      {/* Overlay for better text contrast */}
      <div className="hero-overlay" />

      {/* Content Container - Side positioned with highlighted text */}
      <div className="container hero-container">
        <div className="hero-content-wrapper">
          <div className="hero-content">
            <h1 className="hero-title">
              <span className="highlight">{slides[currentSlide].title}</span>
            </h1>
            <h2 className="hero-subtitle">
              <span className="highlight">{slides[currentSlide].subtitle}</span>
            </h2>
            <p className="hero-description">
              <span className="highlight">{slides[currentSlide].description}</span>
            </p>
          </div>
        </div>

        {/* Slider Navigation Arrows */}
        <button className="hero-nav hero-nav-prev" onClick={prevSlide} aria-label="Previous slide">
          <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button className="hero-nav hero-nav-next" onClick={nextSlide} aria-label="Next slide">
          <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>

        {/* Slider Dots Indicator */}
        <div className="hero-dots">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`hero-dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
